export default __webpack_public_path__ + "static/media/AcDryMode.fe6157aa.svg";